const getters = {
  getPermission(state) {
    return state.admin;
  },
};

export default getters;
